export default __webpack_public_path__ + "static/media/f-3.602d0cb9.jpg";